import { createContext } from "react";

export const EntrepreneurExpertsContext = createContext();
